import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccRepairIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccRepairIcon(props: MccRepairIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccRepairIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Repair')}
      {...rest}
    >
      <path
        d="M8.80003 4.19991C8.67787 4.32452 8.60945 4.49207 8.60945 4.66657C8.60945 4.84107 8.67787 5.00862 8.80003 5.13324L9.86669 6.19991C9.99131 6.32206 10.1589 6.39048 10.3334 6.39048C10.5079 6.39048 10.6754 6.32206 10.8 6.19991L13.3134 3.68657C13.6486 4.42736 13.7501 5.25273 13.6043 6.05267C13.4586 6.85261 13.0725 7.58913 12.4975 8.16409C11.9226 8.73905 11.1861 9.12513 10.3861 9.27088C9.58618 9.41663 8.76082 9.31513 8.02003 8.9799L3.41336 13.5866C3.14814 13.8518 2.78843 14.0008 2.41336 14.0008C2.03829 14.0008 1.67858 13.8518 1.41336 13.5866C1.14814 13.3214 0.999146 12.9616 0.999146 12.5866C0.999146 12.2115 1.14814 11.8518 1.41336 11.5866L6.02003 6.97991C5.6848 6.23911 5.5833 5.41375 5.72905 4.61381C5.87481 3.81387 6.26088 3.07734 6.83584 2.50239C7.4108 1.92743 8.14732 1.54135 8.94726 1.3956C9.7472 1.24985 10.5726 1.35135 11.3134 1.68657L8.80003 4.19991Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
